$.fn.yelallery = function (options) {
	
	// Options Parameters
	const config = $.extend({
		show: 3,
		show_sm: null,
		show_md: null,
		show_lg: null,
		show_xl: null
	}, options);


	let data = {};


	// Set Global Variables
	data.container = $(this);
	data.name_yelallery = ($(this).attr('data-yelallery-name') == undefined || $(this).attr('data-yelallery-name') == '') ? 'informacion-adjunta' : $(this).attr('data-yelallery-name');
	data.files_array = [];
	data.slider = {};
	data.zip = {};
	data.zip_folder = {};
	data.zip_download = {};

	data.base_url = $(this).attr('data-base-url');


	// Set Files
	data.files = data.container.children();


	// Get Files Lenght
	data.files_length = data.files.length;
	

	// Set Files Array
	$.each(data.files, function () {
		let url = $(this).attr('data-yelallery-url');
		let name_file = url.replace(/^.*[\\\/]/, '');

		data.files_array.push({
			url: url,
			name: name_file
		});
	});


	// On Init
	// ---------------------------------------
	printYelallery();
	printSlider();
	$(window).on('resize', printYelallery);
	// ---------------------------------------

	
	// Close Slider
	// ----------------------------------------------
	data.slider.closer.on('click', closeSlider);
	// ----------------------------------------------


	// Control Buttons
	// --------------------------------------------------
	data.slider.buttonPrev.on('click', function () {
		prevSlider();
		viewArrowSlide();
	});
	
	data.slider.buttonNext.on('click', function () {
		nextSlider();
		viewArrowSlide();
	});
	// --------------------------------------------------


	/**
	 * Execute Print HTML File Preview
	 */
	function printYelallery() {
		show = validateWidthYelallery();
		printFilePreview(show);
	}


	/**
	 * Print HTML Image Preview
	 * @param {int} show 
	 */
	function printFilePreview(show) {
		
		// Validate Files Show
		if (show >= data.files_length) {
			show = data.files_length;
		}

		// Get Files Surplus
		data.files_surplus = data.files_length - show;
		
		data.html = `<div class="yelallery__wrapper">`;
		
		for (let index = 0; index < show; index++) {
			if (getExtensionName(data.files_array[index].url) == 'pdf') {
				data.html += `<div class="yelallery__image"><div data-url="${data.files_array[index].url}" class="yelallery__pdf" data-yelallery-open="${index}"></div></div>`;
			} else {
				data.html += `<div class="yelallery__image"><img src="${data.files_array[index].url}" data-url="${data.files_array[index].url}" data-yelallery-open="${index}"></div>`;
			}
		}
		
		if (show < data.files_length) {
			if (getExtensionName(data.files_array[show].url) == 'pdf') {
				data.html += `<div class="yelallery__image"><div data-url="${data.files_array[show].url}" class="yelallery__pdf" data-yelallery-open="${show}"></div><span class="yelallery__surplus">+${data.files_surplus}</span></div>`
			} else {
				data.html += `<div class="yelallery__image"><img src="${data.files_array[show].url}" data-url="${data.files_array[show].url}" data-yelallery-open="${show}"><span class="yelallery__surplus">+${data.files_surplus}</span></div>`
			}
		}

		data.html += `</div>`;
		
		data.container.html(data.html);


		// Event to Images
		// ------------------------------------------------------------------------------
		data.files_preview = data.container.find('.yelallery__wrapper').children();
		
		$.each(data.files_preview, function () {
			const file = $(this).children();
			let position = file.attr('data-yelallery-open');
			position = parseInt(position);
			
			$(this).on('click', function () {
				setDataSlide(position);
				openSlider();
				viewArrowSlide();
			});
			// ------------------------------------------------------------------------------
		
		});
	}


	/**
	 * Print HTML Slider
	 */
	function printSlider() {
		data.slider.container = $('[data-yelallery-slider="container"]');

		data.slider.html = `
			<div class="yelallery__slider">
				<div class="yelallery__slider__dialog">
					<div class="yelallery__slider__content">
						<div class="yelallery__slider__closer" data-yelallery-slider="closer"><span class="icon icon-close"></span></div>
						<div class="yelallery__slider__slides">
							<div class="yelallery__slider__slides__wrapper">
		`;

		data.files_array.forEach((image, index) => {

			if (getExtensionName(image.url) == 'pdf') {
				data.slider.html += `
					<div class="slide-pdf" data-url="${image.url}" data-name="${image.name}" data-type="pdf">
						<div class="slide-pdf-header">
							<button type="button" id="viewer-pdf-prev-${index}" data-toggle="prev"></button>
							<span><span id="viewer-pdf-page-num-${index}" data-toggle="page-num"></span> / <span id="viewer-pdf-page-count-${index}" data-toggle="page-count"></span></span>
							<button type="button" id="viewer-pdf-next-${index}" data-toggle="next"></button>
						</div>
						<canvas id="viewer-pdf-canvas-${index}" data-toggle="canvas"></canvas>
						<div class="slide-pdf-nopreview">El documento no se puede ver en este dispositivo.</div>
					</div>`
				;
			} else {
				data.slider.html += `<img src="${image.url}" class="slide-img" data-url="${image.url}" data-name="${image.name}">`;
			}

		});

		data.slider.html += `
							</div>
							<div class="yelallery__slider__arrow is--left" data-yelallery-slider="button-prev"><span class="icon icon-chevron-down"></span></div>
							<div class="yelallery__slider__arrow is--right" data-yelallery-slider="button-next"><span class="icon icon-chevron-down"></span></div>
						</div>
						<div class="yelallery__slider__buttons">
							<a href="#" class="button button--primary button--download" data-yelallery-slider="download-it"><span class="icon icon-download"></span> DESCARGAR</a>
							<a href="#" download="${data.name_yelallery}.zip" class="button button--white button--download is--disabled" data-yelallery-slider="download-all">CARGANDO...</a>
						</div>
					</div>
				</div>
			</div>
		`;

		
		// Set Variables
		data.slider.container.html(data.slider.html);
		data.slider.this = $('.yelallery__slider');
		data.slider.closer = $('[data-yelallery-slider="closer"]');
		data.slider.buttonPrev = $('[data-yelallery-slider="button-prev"]');
		data.slider.buttonNext = $('[data-yelallery-slider="button-next"]');
		
		data.slider.downloadIt = $('[data-yelallery-slider="download-it"]');
		data.slider.downloadAll = $('[data-yelallery-slider="download-all"]');

		data.slider.files = data.slider.container.find('.yelallery__slider__slides__wrapper').children();
		data.slider.files_array = [];
		

		// Set Files Data
		$.each(data.slider.files, function () {
			data.slider.files_array.push({
				this: $(this),
				url: $(this).attr('data-url'),
				name: $(this).attr('data-name')
			});
		});

		data.slider.files_length = data.slider.files.length;


		// Set Control Variables
		data.slider.files_index = 0;
		data.slider.files_max = data.slider.files_length - 1;


		// PDF Viewer
		data.slider.files_pdf = data.slider.files.filter('[data-type="pdf"]');
		data.slider.files_pdf_array = [];

		$.each(data.slider.files_pdf, function () {
			data.slider.files_pdf_array.push({
				id_button_prev: $(this).find('[data-toggle="prev"]').attr('id'),
				id_button_next: $(this).find('[data-toggle="next"]').attr('id'),
				id_page_num: $(this).find('[data-toggle="page-num"]').attr('id'),
				id_page_count: $(this).find('[data-toggle="page-count"]').attr('id'),
				id_canvas: $(this).find('[data-toggle="canvas"]').attr('id'),
				name: $(this).attr('data-name'),
				url: $(this).attr('data-url')
			});
		});
		
		if (data.slider.files_pdf_array.length > 0) {
			data.slider.files_pdf_array.forEach(file => {
				pdfViewer(file, data.base_url);
			});
		}


		// Generate ZIP
		generateZip();
	}


	/**
	 * Responsive Yelellery
	 * @returns Show Files
	 */
	function validateWidthYelallery() {
		const points = { sm: 576, md: 768, lg: 992, xl: 1200 };
		let show = config.show;

		if (config.show_xl != null) {
			if (getWindow() < points.xl) {
				show = config.show_xl;
			}
		}

		if (config.show_lg != null) {
			if (getWindow() < points.lg) {
				show = config.show_lg;
			}
		}

		if (config.show_md != null) {
			if (getWindow() < points.md) {
				show = config.show_md;
			}
		}

		if (config.show_sm != null) {
			if (getWindow() < points.sm) {
				show = config.show_sm;
			}
		}

		return show;
	}


	/**
	 * Generate ZIP
	 */
	async function generateZip() {
		data.zip = new JSZip();
		data.zip_folder = data.zip.folder(data.name_yelallery);

		await data.files_array.reduce(async (previousPromise, image) => {
			await previousPromise;
			const data = await createFile(image);
			return Promise.resolve();
		}, Promise.resolve());

		data.zip.generateAsync({ type: "blob" })
			.then(function (content) {
				data.zip_download = URL.createObjectURL(content);
				data.slider.downloadAll.attr('href', data.zip_download);
				data.slider.downloadAll.html('<span class="icon icon-download"></span> DESCARGAR TODO');
				data.slider.downloadAll.removeClass('is--disabled');
			});
	}


	/**
	 * Create Blob from URL
	 * @param {object} file 
	 * @returns 
	 */
	async function createFile(file) {
		let response = await fetch(file.url);
		let content = await response.blob();
		return data.zip_folder.file(file.name, content);
	}


	/**
	 * Previus Slider
	 */
	function prevSlider() {
		if (data.slider.files_index > 0) {
			data.slider.files_index--;
		}
		
		setDataSlide(data.slider.files_index);
	}
	

	/**
	 * Next Slider
	 */
	function nextSlider() {
		if (data.slider.files_index < data.slider.files_max) {
			data.slider.files_index++;
		}

		setDataSlide(data.slider.files_index);
	}


	/**
	 * Set Data to Slide
	 * @param {int} position 
	 */
	function setDataSlide(position) {
		data.slider.files_index = position;

		data.slider.downloadIt.attr('href', data.slider.files_array[position].url);
		data.slider.downloadIt.attr('download', data.slider.files_array[position].name);

		if (getExtensionName(data.slider.files_array[position].name) == 'pdf') {
			data.slider.downloadIt.html('<span class="icon icon-download"></span> DESCARGAR PDF');
		} else {
			data.slider.downloadIt.html('<span class="icon icon-download"></span> DESCARGAR IMAGEN');
		}
		
		data.slider.files.removeClass('is--active');
		data.slider.files_array[position].this.addClass('is--active');
	}


	/**
	 * Show or Hide Arrow from Slider
	 */
	function viewArrowSlide() {
		(data.slider.files_index == 0) ? data.slider.buttonPrev.hide() : data.slider.buttonPrev.show();
		(data.slider.files_index == data.slider.files_max) ? data.slider.buttonNext.hide() : data.slider.buttonNext.show();
	}


	/**
	 * Open Slider
	 */
	function openSlider() {
		data.slider.this.addClass('is--active');
		$('body').css({ 'overflow': 'hidden' });
	}
	

	/**
	 * Close Slider
	 */
	function closeSlider() {
		data.slider.this.removeClass('is--active');
		$('body').css({ 'overflow': 'auto' });
	}


	/**
	 * Get Extension Name
	 * @param {string} namefile 
	 * @returns 
	 */
	function getExtensionName(filename) {
  	return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
	}


	/**
	 * @returns Get Window Width
	 */
	function getWindow() {
		return $(window).width();
	}
};